document.addEventListener('DOMContentLoaded', function () {
  if (!customElements.get('slider-video-reviews')) {
    customElements.define(
      'slider-video-reviews',
      class SliderTestimonials extends HTMLElement {
        constructor() {
          super();

          this.slider = this.querySelector('.js-slider-slides');
          this.selectors = {
            sliderContainer: '.slider-video-reviews',
            sliderPrev: '[data-slider-prev]',
            sliderNext: '[data-slider-next]',
            slide: '.js-slider-slide',
            video: '.js-video',
            playButton: '.js-play-button',
            ctaButton: '.js-cta-btn',
          };

          this.slideCount = this.querySelectorAll(this.selectors.slide).length - 1;
          this.slideWidth = this.querySelectorAll(this.selectors.slide)[this.slideCount].offsetWidth + 30;
          this.slideWidth0 = this.querySelectorAll(this.selectors.slide)[0].offsetWidth;
          this.sliderUlWidth = this.slideCount * this.slideWidth + this.slideWidth0;
          this.slides = [...this.querySelectorAll(this.selectors.slide)];

          this.mediaQueryList = window.matchMedia('(max-width: 1023px)');

          this.init();
        }

        dragToSlide() {
          const sliderContainer = this.querySelector(this.selectors.sliderContainer);
          let pressed = false;
          let startX = null;
          let x = null;

          sliderContainer.addEventListener('mousedown', (e) => {
            pressed = true;
            startX = e.offsetX - this.slider.offsetLeft;
            sliderContainer.style.cursor = 'grabbing';
          });

          sliderContainer.addEventListener('mouseenter', () => {
            sliderContainer.style.cursor = 'grab';
          });

          sliderContainer.addEventListener('mouseup', () => {
            sliderContainer.style.cursor = 'grab';
            pressed = false;
          });

          sliderContainer.addEventListener('mousemove', (e) => {
            if (!pressed) return;

            e.preventDefault();

            x = e.offsetX;

            if (x < startX) {
              this.moveRight3(this);
              pressed = false;
            } else if (x > startX) {
              this.moveLeft3(this);
              pressed = false;
            }
          });
        }

        selectSlide() {
          this.slides.forEach((slide) => {
            slide.addEventListener('click', (e) => {
              this.slides.forEach((sld) => {
                sld.classList.remove('is-selected');
              });
              slide.classList.add('is-selected');
            });
          });
        }

        stopVideos() {
          [...this.querySelectorAll(this.selectors.playButton)].forEach((el) => {
            const closestSlide = el.closest(this.selectors.slide);
            closestSlide.querySelector(this.selectors.video).pause();
            closestSlide.querySelector(this.selectors.playButton).classList.remove('is-hidden');
            closestSlide.querySelector(this.selectors.ctaButton)?.classList.remove('is-visible');
          });
        }

        playVideo() {
          [...this.querySelectorAll(this.selectors.playButton)].forEach((btn) => {
            btn.addEventListener('click', () => {
              this.stopVideos();
              const video = btn.previousElementSibling;
              video.play();
              btn.classList.add('is-hidden');

              setTimeout(() => {
                btn.nextElementSibling?.classList.add('is-visible');
              }, 1500);

              video.addEventListener('ended', () => {
                video.load();
                btn.classList.remove('is-hidden');
                btn.nextElementSibling?.classList.remove('is-visible');
              });

              video.addEventListener('click', () => {
                video.pause();
                btn.classList.remove('is-hidden');
                btn.nextElementSibling?.classList.remove('is-visible');
              });
            });
          });
        }

        switchSlides() {
          this.slider.addEventListener('touchstart', (e) => {
            const prevSlide = document.querySelector(`${this.selectors.slide}.is-selected`).previousElementSibling;
            const nextSlide = document.querySelector(`${this.selectors.slide}.is-selected`).nextElementSibling;

            if (e.target.closest(this.selectors.slide) == prevSlide) {
              this.stopVideos();
              this.moveLeft3(this);
            } else if (e.target.closest(this.selectors.slide) == nextSlide) {
              this.stopVideos();
              this.moveRight3(this);
            }
          });
        }

        prevNextSlide() {
          this.querySelector(this.selectors.sliderPrev).addEventListener('click', () => {
            this.stopVideos();
            this.moveLeft3(this);
          });

          this.querySelector(this.selectors.sliderNext).addEventListener('click', () => {
            this.stopVideos();
            this.moveRight3(this);
          });
        }

        moveLeft3(el) {
          document.querySelector('.js-slider-slides').animate(
            {
              left: +el.slideWidth,
            },
            200
          ).onfinish = function () {
            document
              .querySelector('.js-slider-slides')
              .prepend(document.querySelector('.js-slider-slides').querySelector(`.js-slider-slide:last-child`));
            document.querySelector('.js-slider-slides').style.left = '';
            el.slides.forEach((slide) => {
              slide.classList.remove('is-selected');
            });

            if (el.mediaQueryList.matches) {
              el.querySelectorAll(el.selectors.slide)[1].classList.add('is-selected');
            } else {
              el.querySelector(`${el.selectors.slide}:nth-child(3)`).classList.add('is-selected');
            }
          };
        }

        moveRight3(el) {
          document.querySelector('.js-slider-slides').animate(
            {
              left: -el.slideWidth,
            },
            200
          ).onfinish = function () {
            document
              .querySelector('.js-slider-slides')
              .append(document.querySelector('.js-slider-slides').querySelector(`.js-slider-slide:first-child`));
            document.querySelector('.js-slider-slides').style.left = '';
            el.slides.forEach((slide) => {
              slide.classList.remove('is-selected');
            });
            if (el.mediaQueryList.matches) {
              el.querySelectorAll(el.selectors.slide)[1].classList.add('is-selected');
            } else {
              el.querySelector(`${el.selectors.slide}:nth-child(3)`).classList.add('is-selected');
            }
          };
        }

        init() {
          this.prevNextSlide();
          this.playVideo();

          const left = () => {
            this.moveLeft3(this);
          };

          const right = () => {
            this.moveRight3(this);
          };

          swipe('.slider-video-reviews', right, left);

          if (this.mediaQueryList.matches) {
            this.querySelectorAll(this.selectors.slide)[1].classList.add('is-selected');
            this.switchSlides();
          } else {
            this.dragToSlide();
            this.querySelectorAll(this.selectors.slide)[2].classList.add('is-selected');
            this.selectSlide();
          }
        }
      }
    );
  }
});